import { createContext } from 'react';

const MetaContext = createContext({ error: null });

export default MetaContext;
